/* ---------------------------------------------------------------------------
   Sprachwoerterbuch (04.09.2026, zweite Sprache).

   custom.js ist eine statische Datei, Liquid und der t-Filter greifen hier
   nicht. Die Sprache kommt vom <html lang>, das Prestige aus request.locale
   setzt; unbekannte Sprachen fallen auf Englisch zurueck. Jeder sichtbare
   Text dieser Datei geht durch yoursT(). Neue Texte: beide Spalten fuellen.
   --------------------------------------------------------------------------- */
var YOURS_LANG = (document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
var YOURS_TEXT = {
  en: {
    err_required: 'Please fill in this field.',
    err_email: 'Please enter a valid email address.',
    book: 'Book',
    enquire: 'Enquire',
    pick_date: 'Pick your date',
    full_day: 'Full day',
    whatsapp: 'Chat on WhatsApp',
    block_text: 'Pick your charter date first — the SeaBob comes aboard on a booked day.',
    block_link: 'Choose a date',
    offer_line: 'Turns a swim stop into the highlight of the day.',
    bottle_line: 'Yours to take home. Waiting on board on the day.',
    offer_button: 'Add',
    for_day: ' for your charter day',
    selected: 'selected',
    available: 'available',
    not_available: 'not available',
    that_day: 'That day',
    day_unavailable: ' is not available — it is either past or already booked. Days with a circle are free.',
    prev_month: 'Previous month',
    next_month: 'Next month',
    none_season: 'Nothing free in the months ahead. The season runs March to the end of October — write to charter@yours.luxe and we will find a date with you.',
    none_ahead: 'Nothing free in the months ahead. Write to charter@yours.luxe and we will find a date with you.',
    searching: 'Looking for the next free date…',
    first_free: 'First free date: ',
    close_booking: 'Close booking',
    shop: 'Shop'
  },
  de: {
    err_required: 'Bitte füllen Sie dieses Feld aus.',
    err_email: 'Bitte geben Sie eine gültige E-Mail-Adresse ein.',
    book: 'Buchen',
    enquire: 'Anfragen',
    pick_date: 'Datum wählen',
    full_day: 'Ganzer Tag',
    whatsapp: 'Per WhatsApp schreiben',
    block_text: 'Wählen Sie zuerst Ihren Chartertag — der SeaBob kommt an einem gebuchten Tag an Bord.',
    block_link: 'Datum wählen',
    offer_line: 'Macht aus dem Badestopp den Höhepunkt des Tages.',
    bottle_line: 'Zum Mitnehmen. Am Chartertag liegt sie an Bord bereit.',
    offer_button: 'Hinzufügen',
    for_day: ' für Ihren Chartertag',
    selected: 'ausgewählt',
    available: 'frei',
    not_available: 'nicht verfügbar',
    that_day: 'Dieser Tag',
    day_unavailable: ' ist nicht verfügbar — er liegt in der Vergangenheit oder ist bereits gebucht. Tage mit Kreis sind frei.',
    prev_month: 'Vorheriger Monat',
    next_month: 'Nächster Monat',
    none_season: 'In den kommenden Monaten ist nichts frei. Die Saison läuft von März bis Ende Oktober — schreiben Sie an charter@yours.luxe, wir finden einen Termin mit Ihnen.',
    none_ahead: 'In den kommenden Monaten ist nichts frei. Schreiben Sie an charter@yours.luxe, wir finden einen Termin mit Ihnen.',
    searching: 'Der nächste freie Termin wird gesucht …',
    first_free: 'Erster freier Termin: ',
    close_booking: 'Buchung schließen',
    shop: 'Shop'
  },
  es: {
    err_required: 'Por favor, rellene este campo.',
    err_email: 'Introduzca una dirección de correo electrónico válida.',
    book: 'Reservar',
    enquire: 'Consultar',
    pick_date: 'Elija su fecha',
    full_day: 'Día completo',
    whatsapp: 'Escríbanos por WhatsApp',
    block_text: 'Elija primero la fecha de su chárter: el SeaBob sube a bordo el día reservado.',
    block_link: 'Elegir fecha',
    offer_line: 'Convierte una parada para nadar en el gran momento del día.',
    bottle_line: 'Para llevársela a casa. Le espera a bordo el día del chárter.',
    offer_button: 'Añadir',
    for_day: ' para su día de chárter',
    selected: 'seleccionado',
    available: 'disponible',
    not_available: 'no disponible',
    that_day: 'Ese día',
    day_unavailable: ' no está disponible: ya ha pasado o está reservado. Los días con círculo están libres.',
    prev_month: 'Mes anterior',
    next_month: 'Mes siguiente',
    none_season: 'No quedan fechas libres en los próximos meses. La temporada va de marzo a finales de octubre: escríbanos a charter@yours.luxe y buscaremos una fecha con usted.',
    none_ahead: 'No quedan fechas libres en los próximos meses. Escríbanos a charter@yours.luxe y buscaremos una fecha con usted.',
    searching: 'Buscando la próxima fecha libre…',
    first_free: 'Primera fecha libre: ',
    close_booking: 'Cerrar la reserva',
    shop: 'Tienda'
  }
};
/* ---------------------------------------------------------------------------
   Pfade tragen auf der deutschen Seite das Praefix /de.

   Shopify setzt es selbst - in Liquid-Links und im Richtext der Einstellungen.
   NICHT aber in Pfaden, die dieses Skript schreibt. Am 08.09.2026 auf
   /de/products/yours-insulated-bottle gemessen: der Shop-Eintrag der Kopfzeile
   zeigte auf /products/..., die Shop-Zeile im Fussbereich daneben auf
   /de/products/... . Ein Klick haette den Gast aus dem Deutschen geworfen.

   Betrifft alle fuenf Stellen, an denen diese Datei einen Shop-Pfad setzt, also
   auch die BOOK-Pille und die mitlaufende Leiste - dort seit dem 04.09., dem
   Tag, an dem Deutsch live ging.

   Shopify.routes.root ist "/" oder "/de/". Erst beim Setzen aufgeloest, nicht
   beim Laden der Datei: die Kennung steht dann sicher.
   --------------------------------------------------------------------------- */
function yoursUrl(pfad) {
  var wurzel = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  return wurzel.replace(/\/$/, '') + pfad;
}

function yoursT(key) {
  var l = YOURS_TEXT[YOURS_LANG] || YOURS_TEXT.en;
  return (l && l[key] != null) ? l[key] : YOURS_TEXT.en[key];
}

/* ---------------------------------------------------------------------------
   YOURS - Beschriftung des Buchungsknopfes.

   Die App BookEasy liefert "Pick your date"; gewuenscht ist "Book". Sobald ein
   Termin gewaehlt ist, schreibt die App Datum und Slot in dieselbe Stelle
   (bookeasy-widget.js: a.innerText = `${d} | ${e}`). Deshalb wird ausschliesslich
   der Ausgangstext ersetzt und keine spaetere Anzeige angefasst - der Gast sieht
   nach der Wahl weiterhin seinen Termin auf dem Knopf.

   Sauberer waere die App-Einstellung selbst (BookEasy > Appearance > Button
   text). Wird sie gesetzt, kann diese Datei ersatzlos entfallen.
   Angelegt am 19.08.2026.
   --------------------------------------------------------------------------- */
(function () {
  var FROM = 'Pick your date';
  var TO = yoursT('book');

  function apply() {
    var labels = document.querySelectorAll('.bookeasy-button-text');
    for (var i = 0; i < labels.length; i++) {
      if (labels[i].textContent.trim() === FROM) {
        labels[i].textContent = TO;
      }
    }
  }

  function watch() {
    apply();
    // Die App baut den Knopf bei jedem Variantenwechsel neu auf.
    new MutationObserver(apply).observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }
})();

/* Burger-Menue: beim Oeffnen die echte Unterkante der Kopfzeile messen und
   dem Dropdown-Panel als --yours-menu-top mitgeben (custom.css nutzt sie).
   Noetig, weil die Ankuendigungsleiste nur am Seitenanfang sichtbar ist und
   eine feste CSS-Zahl deshalb mal zu hoch, mal zu tief saesse. */
(function () {
  var sidebar = document.getElementById('sidebar-menu');
  var header = document.querySelector('header');
  if (!sidebar || !header) return;
  var setTop = function () {
    if (sidebar.hasAttribute('open')) {
      sidebar.style.setProperty('--yours-menu-top', header.getBoundingClientRect().bottom + 'px');
    }
  };
  setTop();
  new MutationObserver(setTop).observe(sidebar, { attributes: true, attributeFilter: ['open'] });
})();

/* Mehrtages-Anfrage (N2, 21.08.2026): Der Anfrage-Link (erkannt am mailto-Betreff, weil Shopifys Richtext-Filter keine eigenen Attribute an <a> duldet) oeffnen das
   Qikify-Formular ("YOURS Enquiry"), statt das Mailprogramm zu starten. Der
   mailto im href bleibt als Rueckfall, falls die App nicht geladen ist. */
document.addEventListener('click', function (ev) {
  var link = ev.target.closest('a[href*="Multi-day%20charter%20enquiry"]');
  if (!link) return;
  var trigger = document.querySelector('.bcontact-trigger-button');
  if (trigger) {
    ev.preventDefault();
    trigger.click();
  }
});

/* WhatsApp-Knopf (24.08.2026): schwimmender Kontaktweg unten links auf allen
   Seiten, Gegenstueck zum Qikify-Reiter unten rechts. Nur Markup - die
   Gestaltung steht in custom.css (.yours-whatsapp-float). */
(function () {
  if (document.querySelector('.yours-whatsapp-float')) return;
  var a = document.createElement('a');
  a.className = 'yours-whatsapp-float';
  a.href = 'https://wa.me/34609500082';
  a.target = '_blank';
  a.rel = 'noopener';
  a.setAttribute('aria-label', yoursT('whatsapp'));
  a.innerHTML = '<svg viewBox="0 0 32 32" width="28" height="28" fill="#ffffff" aria-hidden="true"><path d="M16 3C9.4 3 4 8.3 4 14.9c0 2.6.8 5 2.3 7L4.5 27l5.3-1.7c1.9 1.1 4 1.6 6.2 1.6 6.6 0 12-5.3 12-11.9S22.6 3 16 3zm0 21.6c-2 0-3.9-.6-5.6-1.6l-.4-.2-3.1 1 1-3-.3-.4c-1.2-1.7-1.9-3.7-1.9-5.8 0-5.4 4.6-9.8 10.2-9.8s10.2 4.4 10.2 9.8-4.5 10-10.1 10zm5.6-7.3c-.3-.2-1.8-.9-2.1-1-.3-.1-.5-.2-.7.2-.2.3-.8 1-.9 1.2-.2.2-.3.2-.6.1-.3-.2-1.3-.5-2.4-1.5-.9-.8-1.5-1.8-1.7-2.1-.2-.3 0-.5.1-.6l.5-.6c.2-.2.2-.3.3-.5.1-.2 0-.4 0-.6-.1-.2-.7-1.7-1-2.3-.2-.6-.5-.5-.7-.5h-.6c-.2 0-.5.1-.8.4-.3.3-1.1 1-1.1 2.5s1.1 2.9 1.3 3.1c.2.2 2.2 3.4 5.4 4.7.8.3 1.4.5 1.8.7.8.2 1.5.2 2 .1.6-.1 1.8-.7 2.1-1.4.3-.7.3-1.3.2-1.4-.1-.2-.3-.2-.6-.4z"/></svg>';
  document.body.appendChild(a);
})();

/* Hero-Zeile an den Video-Start koppeln (25.08.2026).

   Der Auftritt der Zeile "Mallorca, entirely your's" liegt in custom.css als
   reine CSS-Animation mit 5,4 s Verzoegerung - dann loest sich hinter dem Boot
   die Gischt auf, und die Zeile wird von links nach rechts freigelegt. Die Animationsuhr laeuft aber ab
   dem ersten Bildaufbau, das Video erst, wenn genug gepuffert ist. Bei kaltem
   Cache stand die Zeile deshalb schon da, waehrend das Boot noch fuhr.

   Deshalb: Animation anhalten, bis das Video wirklich laeuft. Bewusst nur
   anhalten und wieder loslassen, nie selbst einblenden - faellt dieses Skript
   aus, bleibt die CSS-Animation als vollstaendiger Weg bestehen. Die Notbremse
   nach 4 s greift, wenn der Browser das Autoplay verweigert; dann erscheint die
   Zeile eben ohne Bezug zum Video, aber sie erscheint. */
(function () {
  var media = document.querySelector('.content-over-media:has(video)');
  if (!media) return;

  var video = media.querySelector('video');
  // .h1 statt h2: Live rendert <p class="h1">, Test <h2 class="h1">
  var heading = media.querySelector('.slideshow__slide-content .h1');
  if (!video || !heading) return;

  var released = false;

  function release() {
    if (released) return;
    released = true;
    heading.style.animationPlayState = '';
  }

  // Laeuft das Video schon, gibt es nichts zu synchronisieren.
  if (!video.paused && video.currentTime > 0) return;

  heading.style.animationPlayState = 'paused';
  video.addEventListener('playing', release, { once: true });
  setTimeout(release, 4000);
})();

/* Der SeaBob und der Chartertag gehoeren zusammen (26.08.2026).
   Zwei Befunde von Ben am offenen Shop, beide an derselben Naht:
   1. Die SeaBob-Seite hat einen eigenen Kaufknopf, also liess sich der SeaBob
      allein in den Warenkorb legen und allein auschecken - ohne dass je ein
      Chartertag gewaehlt wurde. Der SeaBob ist aber ein Zusatz, kein
      Einzelartikel.
   2. Umgekehrt fehlte der Weg: Wer im Kalender auf "Confirm date" klickt,
      landet sofort im Warenkorb - und bekam den SeaBob dort nirgends mehr
      angeboten.
   Warum im Theme und nicht in der Konfiguration: Shopify kennt keine Regel
   "Produkt X nur zusammen mit Y". Serverseitig ginge das nur mit einer
   Cart-and-Checkout-Validation-Function, und die braucht eine eigene App.
   Beides sitzt an derselben Stelle - ueber dem Checkout-Knopf - und schliesst
   sich gegenseitig aus: entweder fehlt der Chartertag (Riegel) oder der
   SeaBob (Angebot). Produktbild, Preis und Variante kommen zur Laufzeit aus
   /products/seabob.js statt fest eingetragen zu sein; faellt der Abruf aus,
   entfaellt nur das Angebot, der Riegel bleibt. */
(function () {
  var SEABOB_HANDLE = 'seabob';
  var CHARTER_HANDLE = 'yours-full-day';
  var CHARTER_URL = '/products/yours-full-day';
  var PASSPORT_NAME = 'attributes[Passport or ID number]';
  var BLOCK_TEXT = yoursT('block_text');
  var BLOCK_LINK = yoursT('block_link');
  var OFFER_BUTTON = yoursT('offer_button');

  /* Angeboten werden seit dem 08.09.2026 zwei Dinge. Ben hat im Warenkorb den
     SeaBob gesehen und die Flasche vermisst: "willst du vielleicht nicht auch
     doch die Flasche dazu nehmen oder den SeaBob".

     Sie unterscheiden sich in einem Punkt: Der SeaBob kommt an einem GEBUCHTEN
     Tag an Bord und waere ohne Charter im Korb ein Angebot ins Leere; die
     Flasche kann jeder mitnehmen. In der Praxis erscheint auch sie nur mit
     einer Charter im Korb - liegt sie allein darin, ist sie ja schon gekauft.

     Zeile ist die Kurzfassung der Produktbeschreibung; im Warenkorb hat
     niemand Lust auf drei Zeilen. Bild, Preis und Variante kommen zur Laufzeit
     aus /products/<handle>.js, faellt ein Abruf aus, entfaellt nur dieses eine
     Angebot. Reihenfolge hier = Reihenfolge im Warenkorb. */
  var ZUSAETZE = [
    /* SeaBob seit 12.10.2026 in jeder Charter enthalten, kein Zusatz mehr. */
    { handle: 'yours-insulated-bottle', brauchtCharter: false, zeile: 'bottle_line', preisZusatz: '', produkt: null }
  ];

  var state = 'plain'; // plain | blocked | offer
  var offene = [];     // die Zusaetze, die gerade angeboten werden

  function readCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (response) { return response.json(); })
      .catch(function () { return null; });
  }

  function money(cents) {
    var euros = cents / 100;
    /* Schreibweise nach Seitensprache (13.09.2026): englisch €39.90, deutsch und spanisch €39,90. */
    var text = euros % 1 === 0 ? euros.toFixed(0) : euros.toFixed(2);
    return '€' + (YOURS_LANG === 'de' || YOURS_LANG === 'es' ? text.replace('.', ',') : text);
  }

  function sized(url, width) {
    if (!url) return null;
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function stateOf(cart) {
    var items = (cart && cart.items) || [];
    var imKorb = {};
    var hasCharter = false;
    for (var i = 0; i < items.length; i++) {
      imKorb[items[i].handle] = true;
      if (items[i].handle === CHARTER_HANDLE) hasCharter = true;
    }

    offene = [];

    /* Der Riegel geht vor: Liegt ein SeaBob ohne Charter im Korb, ist das
       Einzige, was hier zaehlt, der fehlende Chartertag. Ein Angebot daneben
       waere Laerm. */
    if (imKorb[SEABOB_HANDLE] && !hasCharter) return 'blocked';
    if (items.length === 0) return 'plain';

    for (var j = 0; j < ZUSAETZE.length; j++) {
      var z = ZUSAETZE[j];
      if (!z.produkt) continue;
      if (imKorb[z.handle]) continue;
      if (z.brauchtCharter && !hasCharter) continue;
      offene.push(z);
    }
    return offene.length ? 'offer' : 'plain';
  }

  /* Der Zustand allein reicht als Merker nicht mehr: "offer" kann eine oder
     zwei Karten bedeuten. Ohne die Handles im Merker bliebe eine veraltete
     Karte stehen, wenn sich nur die Auswahl aendert. */
  function signatur() {
    var teile = [];
    for (var i = 0; i < offene.length; i++) teile.push(offene[i].handle);
    return state + (teile.length ? ':' + teile.join(',') : '');
  }

  function buildBlockNote() {
    var note = document.createElement('p');
    note.className = 'yours-cart-note yours-cart-stop';
    note.setAttribute('role', 'status');
    note.appendChild(document.createTextNode(BLOCK_TEXT + ' '));
    var link = document.createElement('a');
    link.href = yoursUrl(CHARTER_URL);
    link.textContent = BLOCK_LINK;
    note.appendChild(link);
    return note;
  }

  function buildOffer(z) {
    var seabob = z.produkt;
    var box = document.createElement('div');
    box.className = 'yours-cart-note yours-cart-offer';
    box.dataset.yoursOffer = z.handle;

    if (seabob.image) {
      var img = document.createElement('img');
      img.className = 'yours-cart-offer-img';
      img.src = sized(seabob.image, 400);
      /* Kein KI-Zusatz im Alt-Text: Ben, 26.08.2026 - an dieser Stelle
         braucht es ihn nicht. Der Hinweis steht im Bild selbst, auf der
         Produktseite in voller Groesse und im Zusatzkasten der
         Buchungsseite als Bildunterschrift. */
      img.alt = seabob.title;
      img.width = 160;
      img.height = 160;
      img.loading = 'lazy';
      box.appendChild(img);
    }

    var text = document.createElement('div');
    text.className = 'yours-cart-offer-text';

    var name = document.createElement('span');
    name.className = 'yours-cart-offer-name';
    name.textContent = seabob.title;
    text.appendChild(name);

    var line = document.createElement('span');
    line.className = 'yours-cart-offer-line';
    line.textContent = yoursT(z.zeile);
    text.appendChild(line);

    var price = document.createElement('span');
    price.className = 'yours-cart-offer-price';
    price.textContent = money(seabob.price) + (z.preisZusatz ? yoursT(z.preisZusatz) : '');
    text.appendChild(price);

    box.appendChild(text);

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'yours-cart-offer-add';
    button.textContent = OFFER_BUTTON;
    button.addEventListener('click', function () {
      button.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ items: [{ id: seabob.id, quantity: 1 }] })
      }).then(function (response) {
        /* Neu laden statt nachzuzeichnen: Die Position, die Summe und die
           Steuerzeile stehen an vier Stellen, und der Warenkorb rendert sie
           serverseitig. Ein Teil-Update waere hier die fehleranfaelligere
           Loesung. */
        if (response.ok) window.location.reload();
        else button.disabled = false;
      }).catch(function () { button.disabled = false; });
    });
    box.appendChild(button);
    return box;
  }

  /* Ausweisnummer und Firmenangaben stehen fuer die Rechnung der Charter. Liegt
     nur ein SeaBob im Warenkorb, gibt es keine Charter und damit nichts zu
     belegen - der Block verlangt dann Angaben fuer etwas, das gar nicht gebucht
     wird. Gesucht wird ueber das Ausweisfeld, versteckt wird seine ganze Gruppe
     (Snippet cart-guest-details), also samt Firma-Kaestchen und dessen Feldern.
     required wird mit ausgehaengt und beim Einblenden zurueckgesetzt: Ein
     verstecktes Pflichtfeld ist fuer den Browser weiterhin pruefpflichtig,
     aber nicht fokussierbar - das Formular scheitert dann stumm. Deshalb zaehlt
     hier jedes Pflichtfeld der Gruppe, nicht nur das Ausweisfeld selbst. */
  function guestDetailGroups() {
    var found = [];
    var inputs = document.querySelectorAll('[name="' + PASSPORT_NAME + '"]');
    for (var i = 0; i < inputs.length; i++) {
      var group = inputs[i].closest('.v-stack') || inputs[i].parentElement;
      if (group) found.push(group);
    }
    return found;
  }

  function paintPassport(hide) {
    var groups = guestDetailGroups();
    for (var i = 0; i < groups.length; i++) {
      var group = groups[i];
      var fields;
      var j;
      if (hide) {
        fields = group.querySelectorAll('[required]');
        for (j = 0; j < fields.length; j++) {
          fields[j].dataset.yoursWasRequired = '1';
          fields[j].required = false;
        }
        group.hidden = true;
      } else {
        group.hidden = false;
        /* Nur zurueckgeben, was vorher auch Pflicht war. Ein Firmenfeld bei
           leerem Kaestchen traegt keinen Merker und bleibt freiwillig. */
        fields = group.querySelectorAll('[data-yours-was-required]');
        for (j = 0; j < fields.length; j++) {
          fields[j].required = true;
          delete fields[j].dataset.yoursWasRequired;
        }
      }
    }
  }

  function stamp(node) {
    node.dataset.yoursState = signatur();
    return node;
  }

  /* Auf der Warenkorbseite steht links die Spalte, in der bis zum 26.08.2026
     das Bestellnotiz-Feld sass. Ben hat es abgeschaltet und den Platz dem
     SeaBob gegeben - dort steht die Karte gross. In der Schublade gibt es
     diese Spalte nicht, da bleibt sie schmal ueber dem Knopf. */
  /* Seit dem 13.09.2026 (Warenkorb 2.0) tragen Seite UND Lade je einen Slot
     [data-yours-offers]; die Karten stehen dort untereinander, unter der
     Ueberschrift aus dem data-heading des Slots ("Also on board"). Die
     .cart-footer der Prestige-Vorlage bleibt als Rueckfall, falls ein
     Theme-Rueckfall die alte Warenkorbseite zurueckbringt. */
  function wideSlots() {
    var slots = document.querySelectorAll('[data-yours-offers]');
    if (slots.length) return Array.prototype.slice.call(slots);
    var legacy = document.querySelector('.cart-footer');
    return legacy ? [legacy] : [];
  }

  function paintWide() {
    var slots = wideSlots();
    var wanted = state === 'offer' ? signatur() : '';
    for (var s = 0; s < slots.length; s++) {
      var slot = slots[s];
      var vorhanden = slot.querySelector(':scope > .yours-cart-offers');
      if (vorhanden && vorhanden.dataset.yoursState === wanted) continue;
      if (vorhanden) vorhanden.remove();
      if (!wanted) continue;

      /* Seit dem 08.09.2026 koennen es zwei Karten sein. Die Fusszeile des
         Prestige-Warenkorbs ist eine flex-Reihe - zwei Karten direkt darin
         stuenden NEBENeinander. Deshalb eine eigene Spalte, die Karten darin
         untereinander. */
      var box = document.createElement('div');
      box.className = 'yours-cart-offers';
      box.dataset.yoursState = wanted;
      if (slot.dataset.heading) {
        var heading = document.createElement('h2');
        heading.className = 'yc-h2';
        heading.textContent = slot.dataset.heading;
        box.appendChild(heading);
      }
      for (var i = 0; i < offene.length; i++) {
        var card = buildOffer(offene[i]);
        card.classList.add('yours-cart-offer--wide');
        box.appendChild(card);
      }
      slot.insertBefore(box, slot.firstChild);
    }
  }

  function paint() {
    document.documentElement.classList.toggle('yours-cart-blocked', state === 'blocked');
    paintPassport(state === 'blocked');
    paintWide();

    var buttons = document.querySelectorAll('button[name="checkout"]');
    for (var i = 0; i < buttons.length; i++) {
      var button = buttons[i];
      var host = button.parentElement;
      if (!host) continue;

      /* Nur neu bauen, wenn sich der Zustand geaendert hat. Ohne diese Probe
         wirft jede Warenkorb-Abfrage den Kasten weg und setzt ihn neu - das
         flackert, verliert den Fokus und macht den Knopf fuer einen Moment
         unklickbar. */
      var vorhanden = host.querySelectorAll('.yours-cart-note');
      if (vorhanden.length && vorhanden[0].dataset.yoursState === signatur()) continue;
      for (var k = 0; k < vorhanden.length; k++) vorhanden[k].remove();

      if (state === 'blocked') {
        host.insertBefore(stamp(buildBlockNote()), button);
      } else if (state === 'offer' && !wideSlots().length) {
        for (var m = 0; m < offene.length; m++) {
          host.insertBefore(stamp(buildOffer(offene[m])), button);
        }
      }

      if (state === 'blocked') button.setAttribute('aria-disabled', 'true');
      else button.removeAttribute('aria-disabled');
    }
  }

  function refresh() {
    return readCart().then(function (cart) {
      if (cart) {
        state = stateOf(cart);
        paint();
      }
      return state === 'blocked';
    });
  }

  /* Der Klick ist die einzige Stelle, die wirklich zaehlt: Er wird immer erst
     angehalten, dann gegen den frischen Warenkorb geprueft und danach - wenn
     alles stimmt - als derselbe Klick noch einmal ausgeloest. Ueber das
     Merkmal am Knopf laeuft der zweite Klick durch diesen Handler hindurch.
     form.submit() waere der falsche Weg: Dabei faellt name="checkout" aus dem
     Formular und Shopify bliebe im Warenkorb stehen. */
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;
    var button = target.closest('button[name="checkout"]');
    if (!button) return;

    if (button.dataset.yoursChecked === '1') {
      delete button.dataset.yoursChecked;
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    refresh().then(function (stillBlocked) {
      if (stillBlocked) {
        var note = button.parentElement && button.parentElement.querySelector('.yours-cart-note');
        if (note && typeof note.scrollIntoView === 'function') note.scrollIntoView({ block: 'nearest' });
        return;
      }
      button.dataset.yoursChecked = '1';
      button.click();
    });
  }, true);

  /* Nachfuehren, wenn sich der Warenkorb aendert. Der Warenkorb-Aufruf des
     Themes laeuft ueber fetch; BookX legt den Chartertag ggf. anders ab,
     deshalb zusaetzlich ein Beobachter auf der Schublade. Beides ist nur
     Anzeige - die Entscheidung faellt oben beim Klick. */
  if (window.fetch) {
    var nativeFetch = window.fetch;
    window.fetch = function () {
      var call = nativeFetch.apply(this, arguments);
      var url = arguments[0];
      if (typeof url !== 'string' && url && url.url) url = url.url;
      if (typeof url === 'string' && url.indexOf('/cart/') !== -1) {
        call.then(function () { setTimeout(refresh, 60); }).catch(function () {});
      }
      return call;
    };
  }

  function watchDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || !window.MutationObserver) return;
    var pending = null;
    new MutationObserver(function () {
      clearTimeout(pending);
      pending = setTimeout(refresh, 250);
    }).observe(drawer, { childList: true, subtree: true });
  }

  function ladeZusatz(z) {
    return fetch(yoursUrl('/products/' + z.handle + '.js'), { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (response) { return response.json(); })
      .then(function (product) {
        var variant = product && product.variants && product.variants[0];
        if (variant && variant.available) {
          z.produkt = {
            id: variant.id,
            title: product.title,
            price: variant.price,
            image: product.featured_image || (product.images && product.images[0]) || null
          };
        }
      })
      .catch(function () {});
  }

  function start() {
    watchDrawer();
    /* Alle Abrufe abwarten, dann einmal zeichnen. Faellt einer aus, bleibt
       sein produkt null und der Zusatz einfach weg. */
    var alle = [];
    for (var i = 0; i < ZUSAETZE.length; i++) alle.push(ladeZusatz(ZUSAETZE[i]));
    Promise.all(alle).then(refresh, refresh);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

/* ---------------------------------------------------------------------------
   Die Uhr der App im Warenkorb (13.09.2026, Warenkorb 2.0).

   BookX haengt nach dem Buchen eine fixierte Pille an das Ende von <body>
   (.bookeasy-reservation-timer-container, Times-Rueckfall, deckt am Desktop
   das Flaschen-Angebot, am Handy den WhatsApp-Knopf) und zaehlt darin in zwei
   Spans (.bookeasy-reservation-timer-minutes / -seconds, "14" und "54s")
   15 Minuten herunter; danach nimmt sie die Charter aus dem Korb und entfernt
   die Pille. Gemessen am 13.09.2026: Light DOM, kein Shadow Root, die App
   sucht ihre Spans jede Sekunde per document.querySelector.

   Deshalb wird die Pille per CSS unsichtbar und ihre Zahlen hier in die
   Zeile am Datum gespiegelt ([data-yours-hold], je eine auf der Seite und in
   der Lade). Nichts an der App wird umgeschrieben; verschwindet die Pille,
   verschwindet die Zeile. Der Text der Zeile kommt aus den Sprachdateien
   (yours.cart.hold_before / hold_after), nicht aus diesem Skript. */
(function () {
  var CONTAINER = '.bookeasy-reservation-timer-container';

  function mirror() {
    var holds = document.querySelectorAll('[data-yours-hold]');
    if (!holds.length) return;
    var container = document.querySelector(CONTAINER);
    var minutes = container && container.querySelector('.bookeasy-reservation-timer-minutes');
    var seconds = container && container.querySelector('.bookeasy-reservation-timer-seconds');
    var mm = minutes ? (minutes.textContent || '').replace(/\D/g, '') : '';
    var ss = seconds ? (seconds.textContent || '').replace(/\D/g, '') : '';
    var live = !!container && (mm !== '' || ss !== '');
    for (var i = 0; i < holds.length; i++) {
      var time = holds[i].querySelector('.yc-hold-time');
      if (live && time) time.textContent = mm + ':' + ss;
      holds[i].hidden = !live;
    }
  }

  /* Die App schreibt jede Sekunde; ein eigener Takt reicht, um mitzuhalten.
     Der Beobachter am <body> faengt das Erscheinen und Verschwinden der Pille
     sofort ab, damit die Zeile nicht eine Sekunde lang eine alte Zahl zeigt. */
  setInterval(mirror, 1000);
  if (window.MutationObserver && document.body) {
    new MutationObserver(mirror).observe(document.body, { childList: true });
  }
  mirror();
})();

/* ---------------------------------------------------------------------------
   YOURS - Das Buchungsfenster haerten (29.08.2026, aus /impeccable harden).

   Der Dialog von BookX ist der einzige Bildschirm dieser Website, auf dem Geld
   entsteht, und er kam in der Kritik vom 29.08.2026 mit drei Luecken heraus:

   1. Er zeigt weder Betrag noch Slot. Der Gast traegt "Full Day - 10:00" und
      2.050 EUR hinein und findet drinnen keines von beidem wieder.
   2. Er sagt nicht, wann der naechste freie Tag ist. Nachgemessen am 29.08.2026:
      mobil rendert die App EINEN Monat, und August hatte zu dem Zeitpunkt genau
      einen freien Tag (den 31.) - 30 Zellen blass, eine Scheibe. Am Desktop
      rendert dieselbe App ZWEI Monate und zeigt im selben Moment 26 freie Tage.
      Es ist also kein Verfuegbarkeitsproblem, sondern ein Monatsrand: Ende jedes
      Monats sieht das Fenster mobil aus wie ausgebucht. Ausserhalb der Saison
      (November bis Februar) waere es tatsaechlich leer.
   3. Er ist ohne Maus nicht bedienbar: Die Tageszellen sind <span> ohne
      tabindex und role, der Dialog hat kein role="dialog", und der Fokus bleibt
      beim Oeffnen draussen (gemessen: document.activeElement === BODY).

   Was hier passiert, ist Zutat, kein Umbau: Wir schreiben nichts in der App um,
   wir haengen nur an. Findet ein Selektor nichts, faellt der jeweilige Teil
   ersatzlos weg und der Dialog verhaelt sich wie bisher - die harmlosere
   Richtung. Alle Knoten tragen data-yours, damit nichts doppelt entsteht, wenn
   die App neu rendert (sie baut den Kalender bei jedem Monatswechsel neu).

   Kann die App das selbst? Wo ja, gehoert es dorthin und dieser Block darf
   schrumpfen. Der Untertitel im Kopf ist so ein Fall - er kommt aus den
   App-Einstellungen und sagt dort bis heute "skipper", waehrend das Theme seit
   dem 29.08.2026 durchgehend "captain" schreibt.
   --------------------------------------------------------------------------- */
(function () {
  var DIALOG = '.bookeasy-widget-content-v2';
  var TITEL_BOX = '.bookeasy-title-container';
  var TITEL = '.bookeasy-title';
  var KALENDER = '.bookeasy-v2-datetime-picker-container';
  var MONATSBLOCK = '.neo-date-table-bookeasy';
  var MONATSTITEL = '.bookeasy-calendar-month-text';
  var TAG = '.neo-day-bookeasy';
  var TAG_FREI = 'neo-day-enabled-bookeasy';
  var TAG_GESPERRT = 'neo-day-disabled-bookeasy';
  var TAG_GEWAEHLT = 'neo-day-selected-bookeasy';
  var BLAETTERN = '.neo-paginate-bookeasy';
  var BLAETTERN_AUS = 'neo-paginate-disabled-bookeasy';
  var SCHLIESSEN = '.bookeasy-close-button';
  var WEITER = '.bookeasy-next-btn';
  var AUSLOESER = '.bookeasy-btn';

  /* Eine ganze Saison weit suchen, dann aufgeben. Maerz bis Oktober sind acht
     Monate; zwoelf deckt auch den Sprung ueber den Jahreswechsel ab. */
  var MAX_MONATSSPRUENGE = 12;
  var MONATE = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];
  /* Deutsche und spanische Kurzformen, falls BookX die Monatsnamen uebersetzt (06.10.2026). */
  var MONATE_ALT = { 'mär': 2, mai: 4, okt: 9, dez: 11, ene: 0, abr: 3, ago: 7, dic: 11 };

  var offen = false;
  var fokusVorher = null;
  var geplant = false;

  function q(sel, wurzel) { try { return (wurzel || document).querySelector(sel); } catch (e) { return null; } }
  function alle(sel, wurzel) { try { return [].slice.call((wurzel || document).querySelectorAll(sel)); } catch (e) { return []; } }

  /* ----- Datum einer Tageszelle -------------------------------------------
     Die Zelle traegt nur die Ziffer. Ihren Monat holt sie aus dem Block, in dem
     sie steht - am Desktop stehen zwei davon nebeneinander, ein globales
     querySelector auf den Monatstitel wuerde also die Haelfte falsch stempeln. */
  function datumVon(zelle) {
    if (!zelle || !zelle.closest) return null;
    var block = zelle.closest(MONATSBLOCK);
    var titel = block && q(MONATSTITEL, block);
    if (!titel) return null;
    var treffer = titel.textContent.trim().match(/([A-Za-z\u00C0-\u00FF]{3})[A-Za-z\u00C0-\u00FF.]*\s+(\d{4})/);
    var tag = parseInt(zelle.textContent.trim(), 10);
    if (!treffer || !tag) return null;
    var kurz = treffer[1].toLowerCase();
    var monat = MONATE.indexOf(kurz);
    if (monat < 0 && MONATE_ALT.hasOwnProperty(kurz)) monat = MONATE_ALT[kurz];
    if (monat < 0) return null;
    return new Date(Date.UTC(parseInt(treffer[2], 10), monat, tag));
  }

  var LANG = { de: 'de-DE', es: 'es-ES' }[YOURS_LANG] || 'en-GB';
  function langesDatum(d) {
    try {
      return new Intl.DateTimeFormat(LANG, {
        weekday: 'long', day: 'numeric', month: 'long', timeZone: 'UTC'
      }).format(d);
    } catch (e) { return ''; }
  }

  function fruehesterFreierTag() {
    var beste = null;
    alle('.' + TAG_FREI).forEach(function (zelle) {
      var d = datumVon(zelle);
      if (d && (!beste || d < beste.datum)) beste = { zelle: zelle, datum: d };
    });
    return beste;
  }

  /* ----- Statuszeile -------------------------------------------------------
     Eine Live-Region unter dem Kalender. Sie beantwortet die Frage, die der
     Kalender offenlaesst ("ist ueberhaupt etwas frei?"), und traegt zugleich
     die Rueckmeldung auf einen gesperrten Tag - heute passiert dort nichts,
     die Fehlerzeile der App bleibt leer. */
  function statusZeile() {
    var vorhanden = q('[data-yours="bx-status"]');
    if (vorhanden) return vorhanden;
    var box = q('.bookeasy-datetime-picker-container');
    if (!box) return null;
    var p = document.createElement('p');
    p.className = 'yours-bx-status';
    p.setAttribute('data-yours', 'bx-status');
    p.setAttribute('role', 'status');
    p.setAttribute('aria-live', 'polite');
    /* Ueber den Kalender, nicht darunter. Unter ihm stand die Zeile mobil
       unterhalb des Falzes (gemessen 390x844: Kalender ab y 289, die Zeile
       darunter ausserhalb des Bildes) - und eine Zeile, die beantwortet, ob
       ueberhaupt etwas frei ist, muss man sehen, bevor man den leeren Monat
       deutet. Sie sitzt deshalb direkt hinter der Slot-Zeile. */
    var summary = q('[data-yours="bx-summary"]');
    if (summary && summary.nextSibling) box.insertBefore(p, summary.nextSibling);
    else if (summary) box.appendChild(p);
    else if (box.firstChild) box.insertBefore(p, box.firstChild);
    else box.appendChild(p);
    return p;
  }

  function sage(text, ton) {
    var p = statusZeile();
    if (!p) return;
    p.textContent = text || '';
    p.setAttribute('data-ton', ton || 'info');
  }

  /* ----- Slot und Preis ueber den Kalender ---------------------------------
     Beide stehen auf der Produktseite und verschwinden beim Oeffnen hinter dem
     Overlay. Gelesen wird, was der Gast tatsaechlich sieht - nicht die
     Variantendaten -, damit die Zeile nicht anders rechnet als die Seite.

     Sie steht ueber "Choose your date" und nicht im Dialogkopf. Erster Versuch
     war der Kopf, direkt unter dem Titel; dort ist .bookeasy-title-container
     aber eine Flex-Spalte fester Hoehe (64 px gemessen), und ein drittes Kind
     hat den App-Titel auf Hoehe 0 gequetscht - er traegt overflow:hidden und
     schrumpft als erster. Ueber dem Kalender ist ohnehin der bessere Platz:
     Was man bucht, gehoert neben die Entscheidung, nicht in die Zierleiste. */
  function kopfzeileErgaenzen() {
    var box = q('.bookeasy-datetime-picker-container');
    if (!box || q('[data-yours="bx-summary"]')) return;
    var slot = q('.py-slots input:checked + .block-swatch');
    var preis = q('.py-price');
    var teile = [];
    if (slot) teile.push(slot.textContent.trim());
    if (preis) teile.push(preis.textContent.trim());
    if (!teile.length) return;
    var p = document.createElement('p');
    p.className = 'yours-bx-summary';
    p.setAttribute('data-yours', 'bx-summary');
    p.textContent = teile.join(' · ');
    if (box.firstChild) box.insertBefore(p, box.firstChild);
    else box.appendChild(p);
  }

  /* ----- Tageszellen bedienbar machen -------------------------------------
     Die App rendert <span> ohne alles. Rolle, Beschriftung und Tastaturweg
     kommen von hier; der Klick bleibt ihrer. */
  function tageAuszeichnen() {
    alle(TAG).forEach(function (zelle) {
      var frei = zelle.classList.contains(TAG_FREI);
      var gewaehlt = zelle.classList.contains(TAG_GEWAEHLT);
      var d = datumVon(zelle);
      var name = d ? langesDatum(d) : zelle.textContent.trim();
      var zustand = gewaehlt ? yoursT('selected') : (frei ? yoursT('available') : yoursT('not_available'));

      zelle.setAttribute('role', 'button');
      zelle.setAttribute('aria-label', name + ' — ' + zustand);
      zelle.setAttribute('aria-disabled', frei ? 'false' : 'true');
      if (gewaehlt) zelle.setAttribute('aria-current', 'date');
      else zelle.removeAttribute('aria-current');
      /* Gesperrte Tage bleiben erreichbar (tabindex 0), damit ein Tastaturgast
         den Monat abtasten kann; aria-disabled sagt dem Vorleseprogramm, dass
         dort nichts zu holen ist. Ein tabindex -1 wuerde die Haelfte des
         Kalenders lautlos verschlucken. */
      zelle.setAttribute('tabindex', '0');

      if (zelle.getAttribute('data-yours-tag')) return;
      zelle.setAttribute('data-yours-tag', '1');
      zelle.addEventListener('keydown', function (ev) {
        if (ev.key !== 'Enter' && ev.key !== ' ' && ev.key !== 'Spacebar') return;
        ev.preventDefault();
        zelle.click();
      });
      zelle.addEventListener('click', function () {
        if (zelle.classList.contains(TAG_FREI)) { sage(''); return; }
        var dd = datumVon(zelle);
        sage((dd ? langesDatum(dd) : yoursT('that_day')) + yoursT('day_unavailable'), 'warn');
      });
    });
  }

  /* ----- Blaetterpfeile ----------------------------------------------------
     Sie funktionieren mit der Maus (nachgemessen Sep -> Oct -> Sep), waren aber
     fuer Tastatur und Vorleseprogramme unsichtbar. Das laesst sich von hier
     beheben; nur das Pfeilbild gehoert der App. */
  function blaetternAuszeichnen() {
    var pfeile = alle(BLAETTERN);
    pfeile.forEach(function (pfeil, i) {
      var aus = pfeil.classList.contains(BLAETTERN_AUS);
      pfeil.setAttribute('role', 'button');
      pfeil.setAttribute('aria-label', i === 0 ? yoursT('prev_month') : yoursT('next_month'));
      pfeil.setAttribute('aria-disabled', aus ? 'true' : 'false');
      pfeil.setAttribute('tabindex', aus ? '-1' : '0');
      if (pfeil.getAttribute('data-yours-nav')) return;
      pfeil.setAttribute('data-yours-nav', '1');
      pfeil.addEventListener('keydown', function (ev) {
        if (ev.key !== 'Enter' && ev.key !== ' ' && ev.key !== 'Spacebar') return;
        ev.preventDefault();
        pfeil.click();
      });
    });
  }

  /* ----- Leerer Monat: weitersuchen ---------------------------------------
     Nur wenn im Blick GAR NICHTS frei ist. Ist auch nur ein Tag frei, bleiben
     wir stehen und sagen bloss, welcher es ist - jemandem den Monat unter den
     Fingern wegzuschieben, waehrend dort ein buchbarer Tag steht, waere
     schlimmer als das Problem. */
  function naechstenFreienMonatSuchen(rest) {
    if (fruehesterFreierTag()) { erstenFreienTagMelden(); return; }
    if (rest <= 0) {
      sage(yoursT('none_season'), 'warn');
      return;
    }
    var pfeile = alle(BLAETTERN);
    var weiter = pfeile[pfeile.length - 1];
    if (!weiter || weiter.classList.contains(BLAETTERN_AUS)) {
      sage(yoursT('none_ahead'), 'warn');
      return;
    }
    sage(yoursT('searching'));
    weiter.click();
    window.setTimeout(function () { naechstenFreienMonatSuchen(rest - 1); }, 400);
  }

  function erstenFreienTagMelden() {
    if (q('.' + TAG_GEWAEHLT)) { sage(''); return; }
    var beste = fruehesterFreierTag();
    if (!beste) return;
    sage(yoursT('first_free') + langesDatum(beste.datum) + '.');
  }

  /* ----- Dialog: Rolle, Fokus, Escape ------------------------------------- */
  function fokussierbare(dlg) {
    return alle('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"]), input, select, textarea', dlg)
      .filter(function (el) { return el.offsetParent !== null || el === document.activeElement; });
  }

  function dialogAuszeichnen(dlg) {
    dlg.setAttribute('role', 'dialog');
    dlg.setAttribute('aria-modal', 'true');
    var titel = q(TITEL, dlg);
    if (titel) {
      if (!titel.id) titel.id = 'yours-bx-titel';
      dlg.setAttribute('aria-labelledby', titel.id);
    } else {
      dlg.setAttribute('aria-label', 'Booking');
    }
    if (!dlg.hasAttribute('tabindex')) dlg.setAttribute('tabindex', '-1');

    var schliessen = q(SCHLIESSEN, dlg);
    if (schliessen && !schliessen.getAttribute('data-yours-close')) {
      schliessen.setAttribute('data-yours-close', '1');
      schliessen.setAttribute('role', 'button');
      schliessen.setAttribute('aria-label', yoursT('close_booking'));
      schliessen.setAttribute('tabindex', '0');
      schliessen.addEventListener('keydown', function (ev) {
        if (ev.key !== 'Enter' && ev.key !== ' ' && ev.key !== 'Spacebar') return;
        ev.preventDefault();
        schliessen.click();
      });
    }

    if (!dlg.getAttribute('data-yours-dlg')) {
      dlg.setAttribute('data-yours-dlg', '1');
      dlg.addEventListener('keydown', function (ev) {
        if (ev.key === 'Escape' || ev.key === 'Esc') {
          var z = q(SCHLIESSEN, dlg);
          if (z) { ev.preventDefault(); z.click(); }
          return;
        }
        if (ev.key !== 'Tab') return;
        /* Fokusfang: ohne ihn tabbt man aus dem Overlay in die Seite dahinter,
           die weiter da ist und weiter Links hat. */
        var liste = fokussierbare(dlg);
        if (!liste.length) return;
        var erster = liste[0], letzter = liste[liste.length - 1];
        if (ev.shiftKey && document.activeElement === erster) { ev.preventDefault(); letzter.focus(); }
        else if (!ev.shiftKey && document.activeElement === letzter) { ev.preventDefault(); erster.focus(); }
      });
    }
  }

  function anwenden() {
    var dlg = q(DIALOG);
    if (!dlg) {
      if (offen) {
        offen = false;
        if (fokusVorher && document.contains(fokusVorher)) { try { fokusVorher.focus(); } catch (e) {} }
        fokusVorher = null;
      }
      return;
    }
    dialogAuszeichnen(dlg);
    kopfzeileErgaenzen();
    tageAuszeichnen();
    blaetternAuszeichnen();

    if (!offen) {
      offen = true;
      fokusVorher = q(AUSLOESER);
      try { dlg.focus(); } catch (e) {}
      /* Der Kalender braucht rund 500 ms, bis die Verfuegbarkeit steht
         (gemessen 29.08.2026). Vorher zu urteilen hiesse, einen Ladezustand
         fuer eine Aussage zu halten - genau der Fehler, der die Kritik an
         dieser Stelle zuerst danebenliegen liess. */
      window.setTimeout(function () {
        if (!q(DIALOG)) return;
        naechstenFreienMonatSuchen(MAX_MONATSSPRUENGE);
      }, 900);
    }
  }

  function planen() {
    if (geplant) return;
    geplant = true;
    window.requestAnimationFrame(function () {
      geplant = false;
      try { anwenden(); } catch (e) { /* nie in die App hineinwerfen */ }
    });
  }

  function start() {
    /* Kein Vorab-Ausstieg auf "gibt es den Knopf?": custom.js laeuft mit defer,
       also zu DOMContentLoaded -- und BookX haengt seinen Knopf erst danach ein.
       Ein Guard an dieser Stelle hat den ganzen Block stillgelegt (gemessen am
       29.08.2026: kein einziges Attribut gesetzt). Der Beobachter laeuft
       deshalb immer; anwenden() steigt in einer Zeile aus, wenn kein Dialog
       offen ist, und kostet damit nichts. */
    planen();
    if (window.MutationObserver) {
      new MutationObserver(planen).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
/* ---------------------------------------------------------------------------
   YOURS - Buchungsweg in die Kopfzeile (29.08.2026, aus /impeccable layout).

   Die klebende Kopfzeile laeuft ueber die ganze Kette mit -- gemessen 15.027 px
   auf dem Handy -- und trug bisher Logo, Hamburger, Konto und Warenkorb. Also
   in einem Ein-Boot-Shop zwei Symbole fuer Nebenwege und keines fuer den
   Hauptweg. Zwischen der Ratenkarte und dem Seitenende der Startseite lagen
   dadurch 3.333 px ohne jede Handlung.

   Warum per Skript und nicht in header.liquid: header.liquid ist Prestige-Code.
   Wer ihn anfasst, verliert fuer diese Datei den Upgrade-Pfad. Dieselbe
   Entscheidung war schon beim WhatsApp-Knopf richtig; das Muster steht.

   Der Knopf erscheint ab 1000 px (darunter fuehrt der Weg ueber das Menue, und
   eine dritte Marke neben Hamburger und Warenkorb waere dort Gedraenge) und
   nicht auf der Produktseite selbst, wo die grosse Pille im Inhalt steht.
   Beides regelt custom.css.
   --------------------------------------------------------------------------- */
(function () {
  /* Seit 12.10.2026 Anfrage statt Buchung: Ziel ist das Formular auf der Charter-Seite. */
  var ZIEL = '/pages/charter-yours#request';
  var TEXT = yoursT('enquire');

  function einbauen() {
    var nav = document.querySelector('.header__secondary-nav ul, .header__secondary-nav');
    if (!nav || nav.querySelector('[data-yours="header-cta"]')) return true;

    var li = document.createElement('li');
    li.className = 'yours-header-cta';
    li.setAttribute('data-yours', 'header-cta');

    var a = document.createElement('a');
    a.href = yoursUrl(ZIEL);
    a.className = 'yours-header-cta-link';
    a.textContent = TEXT;

    li.appendChild(a);
    /* Vor das Konto-Symbol, damit der Hauptweg links von den Nebenwegen steht
       und der Warenkorb aussen bleibt, wo man ihn sucht. */
    var konto = nav.querySelector('.header__account-link');
    var warenkorb = nav.querySelector('.header__cart-link');
    var anker = konto || warenkorb;
    if (anker && anker.parentNode === nav) nav.insertBefore(li, anker);
    else nav.appendChild(li);
    return true;
  }

  function start() {
    if (einbauen()) return;
    /* Die Kopfzeile ist Theme-Markup und steht beim DOMContentLoaded; der
       Beobachter ist nur der Rueckfall, falls ein Abschnitt neu gerendert wird
       (Theme-Editor). Er haelt sich selbst kurz. */
    if (!window.MutationObserver) return;
    var mo = new MutationObserver(function () { if (einbauen()) mo.disconnect(); });
    mo.observe(document.body, { childList: true, subtree: true });
    window.setTimeout(function () { mo.disconnect(); }, 10000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
/* ---------------------------------------------------------------------------
   YOURS - Der Shop-Eintrag in der Kopfzeile (08.09.2026, Bens Entscheidung).

   Warum rechts und nicht links im Menue: am 08.09. im Live-Theme bei 1440 px
   gemessen. Das Menue endet bei x=530, das Logo beginnt bei x=570 -- vierzig
   Pixel. Ein fuenfter Punkt links laesst die Zeile umbrechen, "Shop" faellt
   unter "Home" und die Kopfzeile wird hoeher; probeweise in das DOM gesetzt
   und nachgesehen. Rechts stehen 235 px gegen 482 px links; mit Shop und
   Warenkorb werden daraus 367 px.

   Warum per Skript und nicht ueber das Menue im Admin: das Admin-Menue speist
   die LINKE Seite und den Burger. Ein Eintrag dort erschiene sofort links --
   also genau da, wo er nicht hinpasst -- und im Live-Theme obendrein. Dasselbe
   Muster wie bei der BOOK-Pille darueber; header.liquid bleibt unberuehrt und
   behaelt den Upgrade-Pfad.

   Preis dieser Loesung: Text und Ziel stehen hier, nicht im Admin.

   Mobil ist die Zeile schon mit Burger, Logo, Warenkorb und Pille voll. Dort
   haengt der Eintrag stattdessen unten in der Liste des Burger-Menues.
   --------------------------------------------------------------------------- */
(function () {
  var ZIEL = '/products/yours-insulated-bottle';
  var TEXT = yoursT('shop');

  function inKopfzeile() {
    var nav = document.querySelector('.header__secondary-nav ul, .header__secondary-nav');
    if (!nav || nav.querySelector('[data-yours="header-shop"]')) return true;

    var li = document.createElement('li');
    li.className = 'yours-header-shop';
    li.setAttribute('data-yours', 'header-shop');

    var a = document.createElement('a');
    a.href = yoursUrl(ZIEL);
    /* h6 ist die Klasse, die Prestige seinen eigenen Menuepunkten gibt
       (dort "block h6"). Sie bringt Ueberschriftenschrift und -gewicht mit.
       Ohne sie lief der Eintrag in der Fliesstextschrift: am 08.09.2026
       gemessen IBM Plex Sans 400 gegen Instrument Sans 600 der Nachbarn,
       er sah neben ihnen duenn aus. Ben hat es gesehen, bevor ich es mass. */
    a.className = 'yours-header-shop-link h6';
    a.textContent = TEXT;

    li.appendChild(a);
    /* Ganz nach vorn; die Reihenfolge Shop, Tasche, Sprache, Pille macht
       custom.css mit order, damit sie auch nach einem Neu-Rendern stimmt. */
    nav.insertBefore(li, nav.firstChild);
    return true;
  }

  function inBurger() {
    var liste = document.querySelector('.header-sidebar__linklist');
    if (!liste) return false;
    if (liste.querySelector('[data-yours="sidebar-shop"]')) return true;

    var vorlage = liste.querySelector('li');
    if (!vorlage) return false;

    var li = vorlage.cloneNode(false);
    li.setAttribute('data-yours', 'sidebar-shop');

    var muster = liste.querySelector('a.header-sidebar__linklist-button');
    var a = document.createElement('a');
    a.href = yoursUrl(ZIEL);
    a.className = muster ? muster.className : 'header-sidebar__linklist-button';
    a.textContent = TEXT;

    li.appendChild(a);
    liste.appendChild(li);
    return true;
  }

  function start() {
    inKopfzeile();
    /* Der Burger steckt in einem Dialog, den Prestige erst spaet fuellt.
       Deshalb hier ein kurzer Beobachter, der sich selbst beendet. */
    if (inBurger()) return;
    if (!window.MutationObserver) return;
    var mo = new MutationObserver(function () { if (inBurger()) mo.disconnect(); });
    mo.observe(document.body, { childList: true, subtree: true });
    window.setTimeout(function () { mo.disconnect(); }, 10000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
/* ---------------------------------------------------------------------------
   YOURS - Der Kaufknopf im Angebot gehoert dem Theme (08.09.2026).

   Befund: Auf der Charterseite haengt BookEasy sich an JEDEN Absende-Knopf
   eines Produktformulars. Auch an den der Flaschen-Karte im Angebot der
   Warenkorb-Lade. Gemessen am 08.09.2026 - der Knopf trug dort
   bookeasy-button-id="15650541207883" und bookeasy-listener="true", ein Klick
   fuehrte zu nichts: BookEasy schluckte ihn, die Flasche landete nicht im
   Korb. Ausgerechnet auf der Seite, auf der das Angebot am meisten zaehlt.

   Die Reparatur ist ein Austausch, kein Gegen-Listener: ein Klon des Knopfes
   traegt keine fremden Ereignis-Hoerer mehr, wohl aber dessen Attribute -
   BookEasy sieht sein eigenes bookeasy-listener und bindet nicht erneut. Der
   Klon ist weiterhin type="submit", also greift wieder das, was greifen soll:
   <product-form> von Prestige, das am Formular haengt und die Lade danach
   selbst neu zeichnet.

   Der Beobachter ist noetig, weil BookEasy erst nach dem Laden bindet und die
   Lade sich bei jeder Aenderung neu rendert.
   --------------------------------------------------------------------------- */
(function () {
  var AUSWAHL = '.complementary-products button[bookeasy-listener]';

  function befreien() {
    var knoepfe = document.querySelectorAll(AUSWAHL);
    for (var i = 0; i < knoepfe.length; i++) {
      var alt = knoepfe[i];
      if (alt.getAttribute('data-yours-frei') === '1') continue;
      var neu = alt.cloneNode(true);
      neu.setAttribute('data-yours-frei', '1');
      if (alt.parentNode) alt.parentNode.replaceChild(neu, alt);
    }
  }

  function start() {
    befreien();
    document.addEventListener('cart-drawer:refreshed', befreien);
    document.addEventListener('cart:refresh', befreien);
    if (!window.MutationObserver) return;
    /* Attribute UND Kindknoten: das eine ist BookEasys Bindung, das andere das
       Neuzeichnen der Lade. */
    new MutationObserver(befreien).observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['bookeasy-listener']
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
/* ---------------------------------------------------------------------------
   YOURS - Der Buchungsweg bleibt erreichbar (29.08.2026, /impeccable adapt).

   Befund der Kritik, mobil nachgemessen: Auf der Startseite liegen zwischen
   der Unterkante des Buchungsknopfs (y 1.320) und der naechsten Handlung
   (y 4.420) 3.100 px. Auf der Produktseite folgen nach BOOK rund 3.800 px --
   Galerie, SeaBob, Raten, Joost, sechs FAQ -- ohne zweiten Buchungsknopf.
   Genau die Inhalte also, die einen Zoegernden umdrehen, und danach nichts
   zum Anfassen. Produktprinzip 1 aus PRODUCT.md verlangt das Gegenteil: von
   jeder Stelle der Seite in einem Schritt zur Datumswahl.

   EINE Regel, zwei Ausdruecke - jede Groesse benutzt das Mittel, das sie
   ohnehin hat:
   - unter 1000 px: diese Leiste am unteren Rand, wo der Daumen ist;
   - ab 1000 px: die BOOK-Pille in der Kopfzeile, die seit dem 29.08. mitlaeuft.
     Auf der Produktseite war sie ausgeblendet, weil die grosse Pille im Inhalt
     steht -- das stimmt aber nur, solange die im Bild ist. Dieselbe Klasse
     blendet sie dort jetzt wieder ein, sobald die Pille weg ist.

   Die Leiste erscheint nie neben einem sichtbaren Buchungsknopf: ein
   IntersectionObserver beobachtet alle Knoepfe der Seite, und solange auch nur
   einer im Bild ist, bleibt sie unten. Damit ist sie kein Dauerbanner, sondern
   der Ersatz fuer etwas, das gerade nicht zu sehen ist.

   Abweichung vom Surface-Brief der Produktseite: dort steht "Ein Sticky-Band
   ist nicht vorgesehen. Rutscht die Pille mobil unter y = 1000 px, ist das
   Band der Rueckfallplan." Die Pille liegt bei y 724, die Bedingung ist also
   nicht erfuellt. Jene Regel war ueber den ERSTEN Bildschirm geschrieben; der
   Befund betrifft die 3.800 px danach. Von Ben am 29.08.2026 mit dem
   P1-Umfang ausdruecklich freigegeben. Der Brief gehoert nachgezogen.
   --------------------------------------------------------------------------- */
(function () {
  /* [data-yours-request]: Ueber dem Anfrageformular hat die Leiste nichts zu suchen (12.10.2026). */
  var CTAS = '.hy-btn, .cy-btn, .py-book .bookeasy-btn, .shopify-section--rich-text .button, [data-yours-request]';
  var DIALOG = '.bookeasy-widget-content-v2';
  var PRODUKT_URL = '/pages/charter-yours#request';

  var leiste = null;
  var sichtbareKnoepfe = 0;
  var vorbeigekommen = false;

  function text(sel) {
    var e = document.querySelector(sel);
    return e ? e.textContent.trim() : '';
  }

  /* Preis und Unterzeile kommen von der Seite, nicht aus einer zweiten
     Wahrheit: Was in der Leiste steht, muss dasselbe sein wie oben. */
  function inhalt() {
    if (document.querySelector('.py-price')) {
      var slot = text('.py-slots input:checked + .block-swatch');
      return { preis: text('.py-price'), unter: slot || yoursT('full_day'), label: yoursT('book'), appKnopf: true };
    }
    if (document.querySelector('.cy-price')) {
      return { preis: text('.cy-price'), unter: yoursT('full_day'), label: yoursT('pick_date'), appKnopf: false };
    }
    if (document.querySelector('.hy-price')) {
      return { preis: text('.hy-price'), unter: yoursT('full_day'), label: yoursT('pick_date'), appKnopf: false };
    }
    return null;
  }

  function bauen() {
    var i = inhalt();
    if (!i || !i.preis) return null;

    var bar = document.createElement('div');
    bar.className = 'yours-stickybar';
    bar.setAttribute('data-yours', 'stickybar');
    /* Kein role="region" mit Label: die Leiste wiederholt nur, was die Seite
       schon sagt. Fuer Vorleseprogramme ist sie damit doppelt; aria-hidden
       waere aber falsch, weil sie den einzigen erreichbaren Knopf traegt.
       Also unauffaellig lassen und den Knopf sprechen lassen. */
    var innen = document.createElement('div');
    innen.className = 'yours-stickybar-inner';

    var preis = document.createElement('p');
    preis.className = 'yours-stickybar-price';
    preis.textContent = i.preis;
    var unter = document.createElement('span');
    unter.className = 'yours-stickybar-sub';
    unter.textContent = i.unter;
    preis.appendChild(unter);

    var knopf;
    if (i.appKnopf) {
      knopf = document.createElement('button');
      knopf.type = 'button';
      knopf.addEventListener('click', function () {
        var echt = document.querySelector('.py-book .bookeasy-btn');
        if (echt) { echt.click(); return; }
        window.location.href = yoursUrl(PRODUKT_URL);   /* Rueckfall, falls die App fehlt */
      });
    } else {
      knopf = document.createElement('a');
      knopf.href = yoursUrl(PRODUKT_URL);
    }
    knopf.className = 'yours-stickybar-btn';
    knopf.textContent = i.label;

    innen.appendChild(preis);
    innen.appendChild(knopf);
    bar.appendChild(innen);
    document.body.appendChild(bar);
    return bar;
  }

  function auffrischen() {
    if (!leiste) return;
    var i = inhalt();
    if (!i) return;
    var p = leiste.querySelector('.yours-stickybar-price');
    var u = leiste.querySelector('.yours-stickybar-sub');
    if (p && u && (p.firstChild.nodeValue !== i.preis || u.textContent !== i.unter)) {
      p.firstChild.nodeValue = i.preis;
      u.textContent = i.unter;
    }
  }

  function zeigen(an) {
    if (!leiste) return;
    document.documentElement.classList.toggle('yours-cta-away', an);
    leiste.classList.toggle('is-on', an);
  }

  function pruefen() {
    /* Ueber dem Buchungsfenster hat die Leiste nichts zu suchen. */
    if (document.querySelector(DIALOG)) { zeigen(false); return; }
    zeigen(vorbeigekommen && sichtbareKnoepfe === 0);
  }

  function start() {
    /* Nicht auf "gibt es schon Knoepfe?" aussteigen: custom.js laeuft mit
       defer, BookX haengt seinen Knopf erst danach ein. Genau dieser Guard
       hatte den Block beim ersten Anlauf stillgelegt (29.08.2026 gemessen:
       auf der Produktseite wurde die Leiste nie gebaut) -- derselbe Fehler
       wie im Buchungsfenster-Block darueber, zweimal an einem Tag.
       Also warten, bis mindestens ein Knopf da ist. */
    if (!document.querySelector(CTAS)) {
      if (!window.MutationObserver) return;
      var warte = new MutationObserver(function () {
        if (!document.querySelector(CTAS)) return;
        warte.disconnect();
        einrichten();
      });
      warte.observe(document.body, { childList: true, subtree: true });
      window.setTimeout(function () { warte.disconnect(); }, 15000);
      return;
    }
    einrichten();
  }

  function einrichten() {
    leiste = bauen();
    if (!leiste) return;

    /* Sichtbarkeit direkt messen statt ueber einen IntersectionObserver.
       Grund, gemessen am 29.08.2026: BookX baut seinen Knopf bei jedem
       Variantenwechsel neu auf. Der Beobachter hing danach an einem
       abgehaengten Knoten, meldete nie wieder "sichtbar" -- und die Leiste
       blieb oben am Seitenanfang stehen, neben dem Knopf, den sie ersetzen
       soll. Ein frisches querySelectorAll bei jedem Tick kennt dieses
       Problem nicht und kostet bei drei Elementen nichts. */
    var geplant = false;
    function messen() {
      geplant = false;
      var knoepfe = [].slice.call(document.querySelectorAll(CTAS));
      var vorbei = 0;
      sichtbareKnoepfe = 0;
      knoepfe.forEach(function (k) {
        var r = k.getBoundingClientRect();
        if (r.height <= 0) return;
        if (r.bottom <= 8) vorbei++;                                  /* nach oben rausgescrollt */
        else if (r.top < window.innerHeight - 8) sichtbareKnoepfe++;  /* im Bild */
      });
      /* Erst zeigen, wenn der Gast an einem Knopf VORBEI ist. Ohne diese
         Bedingung stand die Leiste schon ueber dem Hero der Startseite, wo
         der erste Knopf 1.264 px tiefer liegt - also bevor der Gast ihn
         ueberhaupt gesehen hat. Das ist ein Banner, kein Ersatz. */
      vorbeigekommen = vorbei > 0;
      auffrischen();
      pruefen();
    }
    function planen() {
      if (geplant) return;
      geplant = true;
      window.requestAnimationFrame(messen);
    }

    planen();
    window.addEventListener('scroll', planen, { passive: true });
    window.addEventListener('resize', planen);
    document.addEventListener('change', planen);
    if (window.MutationObserver) {
      new MutationObserver(planen).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

/* ---------------------------------------------------------------------------
   YOURS - Kontaktformular: eigene Fehlermeldungen (09.09.2026, Critique).

   Prestige verlaesst sich auf die Browser-Validierung: leer abschicken gab
   einen Tooltip in der Browsersprache ("Fuelle dieses Feld aus." auf der
   englischen Seite), das Feld blieb ohne Kennzeichnung, kein aria-invalid.
   Hier: novalidate, Pruefung der Pflichtfelder und der E-Mail, Meldung in
   Tinte unter dem Feld, aria-invalid + aria-describedby, Fokus auf das erste
   fehlende Feld. Loescht sich beim Tippen.
   --------------------------------------------------------------------------- */
(function () {
  var form = document.querySelector('.shopify-section--contact form[action*="/contact"]');
  if (!form) return;
  form.setAttribute('novalidate', '');

  function feld(el) { return el.closest('.form-control') || el.parentNode; }
  function meldung(el, text) {
    var box = feld(el);
    var p = box.querySelector('.yours-field-error');
    if (!text) {
      if (p) p.remove();
      el.removeAttribute('aria-invalid');
      el.removeAttribute('aria-describedby');
      return;
    }
    if (!p) {
      p = document.createElement('p');
      p.className = 'yours-field-error';
      p.id = (el.id || ('f' + Math.random().toString(36).slice(2))) + '-error';
      box.appendChild(p);
    }
    p.textContent = text;
    el.setAttribute('aria-invalid', 'true');
    el.setAttribute('aria-describedby', p.id);
  }
  function pruefe(el) {
    var v = (el.value || '').trim();
    if (el.required && !v) return yoursT('err_required');
    if (el.type === 'email' && v && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) return yoursT('err_email');
    return '';
  }
  var felder = form.querySelectorAll('input:not([type=hidden]):not([type=submit]), textarea, select');
  felder.forEach(function (el) {
    el.addEventListener('input', function () { if (el.getAttribute('aria-invalid')) meldung(el, pruefe(el)); });
  });
  function alles() {
    var erstes = null;
    felder.forEach(function (el) {
      var t = pruefe(el);
      meldung(el, t);
      if (t && !erstes) erstes = el;
    });
    return erstes;
  }
  /* Shopifys Captcha-Skript haengt sich an submit, verhindert es selbst und
     schickt das Formular nach dem Loesen per form.submit() ab - daran kommt ein
     eigener submit-Handler nicht mehr vorbei (09.09.2026 gemessen: Weiterleitung
     auf /challenge trotz preventDefault). Deshalb schon den Klick auf den
     Sendeknopf abfangen, in der Capture-Phase, bevor irgendwer submit sieht.
     Enter im Feld loest denselben Klick aus. */
  form.addEventListener('click', function (e) {
    var knopf = e.target && e.target.closest && e.target.closest('button[type="submit"], input[type="submit"]');
    if (!knopf) return;
    var erstes = alles();
    if (erstes) { e.preventDefault(); e.stopImmediatePropagation(); erstes.focus(); }
  }, true);
  form.addEventListener('submit', function (e) {
    var erstes = alles();
    if (erstes) { e.preventDefault(); e.stopImmediatePropagation(); erstes.focus(); }
  }, true);
})();

/* ---------------------------------------------------------------------------
   YOURS - WhatsApp-Scheibe weicht der Gold-Pille (09.09.2026, Critique).

   Gemessen auf der Startseite bei 390 x 844: beim Ablauf-Block liegt die
   gruene Scheibe (20-76 x 768-824) exakt auf der zweiten Pille (20-181 x
   764-812). Statt Seite fuer Seite auszublenden wird gemessen: schneidet
   irgendeine .yh-pill das Rechteck der Scheibe, bekommt <html> die Klasse
   yours-wa-clash und custom.css nimmt die Scheibe zurueck. Kommt die Pille
   aus dem Bild, ist sie wieder da.
   --------------------------------------------------------------------------- */
(function () {
  var scheibe = null, pillen = null, offen = false;
  function messen() {
    offen = false;
    if (!scheibe) scheibe = document.querySelector('.yours-whatsapp-float');
    if (!scheibe) return;
    if (!pillen || !pillen.length) pillen = document.querySelectorAll('.yh-pill');
    var s = scheibe.getBoundingClientRect();
    if (!s.width) return;
    var clash = false;
    for (var i = 0; i < pillen.length; i++) {
      var p = pillen[i].getBoundingClientRect();
      if (!p.width) continue;
      if (p.left < s.right + 8 && p.right > s.left - 8 && p.top < s.bottom + 8 && p.bottom > s.top - 8) { clash = true; break; }
    }
    document.documentElement.classList.toggle('yours-wa-clash', clash);
  }
  function anfordern() {
    if (offen) return;
    offen = true;
    window.requestAnimationFrame(messen);
  }
  function start() {
    if (!document.querySelector('.yh-pill')) return;
    window.addEventListener('scroll', anfordern, { passive: true });
    window.addEventListener('resize', anfordern);
    /* Die Scheibe kommt aus custom.js selbst, aber spaeter; zweimal nachsehen. */
    setTimeout(messen, 600);
    setTimeout(messen, 2500);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
